<template><svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_778_1100)">
<path d="M16.6665 0V100H74.9998L99.9998 75V0H16.6665Z" fill="url(#paint0_linear_778_1100)"/>
<path d="M75 75V100L100 75H75Z" fill="#ABABAB"/>
<path d="M50 100H75V75L50 100Z" fill="#DEDEDD"/>
<path d="M0 25V54.1667H66.6667V25H0Z" fill="#2B5529"/>
<path d="M20.0333 33.6418H16.1333V48.5418H12.5333V33.6418H8.6333V30.6918H20.0333V33.6418Z" fill="white"/>
<path d="M23.2583 30.6918H26.8583V48.5418H23.2583V30.6918Z" fill="white"/>
<path d="M41.0087 30.6918V33.6418H34.6379V37.8418H40.6337V40.7918H34.6379V48.5418H31.0337V30.6918H41.0087Z" fill="white"/>
<path d="M54.0829 30.6918V33.6418H47.7079V37.8418H53.7079V40.7918H47.7079V48.5418H44.1079V30.6918H54.0829Z" fill="white"/>
</g>
<defs>
<linearGradient id="paint0_linear_778_1100" x1="28.4717" y1="20.1385" x2="138.568" y2="130.234" gradientUnits="userSpaceOnUse">
<stop stop-color="#EFEEEE"/>
<stop offset="1" stop-color="#DEDEDD"/>
</linearGradient>
<clipPath id="clip0_778_1100">
<rect width="100" height="100" fill="white"/>
</clipPath>
</defs>
</svg>
</template>